import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  input: {
    width: '90%',
    height: 40,
    paddingLeft: 10,
    borderRadius: 2,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  title: {
    color: 'black',
    marginBottom: 8,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  containerInput: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: Colors.GrayPallete.lightgray,
  },
  forget: {
    textAlign: 'right',
    color: 'black',
    marginTop: 5,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  FullInput: {
    width: '100%',
    height: 40,
    paddingLeft: 10,
    borderRadius: 2,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  containerInputError: {
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
  },
  errorText: {
    color: Colors.RedPallete.red,
    fontSize: 12,
    marginTop: 4,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
});
